<template>
  <div>
    <el-form-item label="查询资源">
      <el-select clearable v-model="data.resourceId" placeholder="请选择查询资源" >
          <el-option
          v-for="item in resource"
          :key="item.resourceId"
          :label="item.tableComment"
          :value="item.resourceId">
          </el-option>
      </el-select>
    </el-form-item>
    <el-divider content-position="left">弹框字段</el-divider>
    <popUpWindowFieldSet :fieldAttrList="fieldAttrList" :fieldDicData="fieldDicData" @replaceData="replaceFieldAttrList" />
    <el-form-item label="过滤条件">
      <el-select clearable v-model="data.filterCondition" placeholder="请选择过滤条件" >
          <el-option
          v-for="item in filterConditionDicData"
          :key="item.value"
          :label="item.label"
          :value="item.value">
          </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="弹出标题">
      <el-input v-model="data.placeholder"></el-input>
    </el-form-item>
    <el-form-item label="最大选择量">
      <el-input-number v-model="data.maxRows"  :min="1" :max="100" ></el-input-number>
    </el-form-item>
    <el-form-item label="是否只读">
      <el-switch v-model="data.disabled"></el-switch>
    </el-form-item>
    <el-form-item label="是否可见">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>
    <el-form-item label="列隐藏" v-if="isDynamic">
      <el-switch v-model="data.hide"></el-switch>
    </el-form-item>
    <el-form-item label="是否必填">
      <el-switch v-model="data.required"></el-switch>
    </el-form-item>
     <!-- <el-form-item label="id回填字段">
      <el-input v-model="data.callIdName"></el-input>
    </el-form-item> -->
    <el-form-item label="联动URL：" label-width="100px" label-position="left">
        <el-input v-model="data.casUrl"></el-input>
    </el-form-item>
  </div>
</template>

<script>
import mixinIsDynamic from '../../mixins/isDynamic'
import popUpWindowFieldSet from '../popUpWindowFieldSet'
export default {
  mixins: [mixinIsDynamic],
  name: 'ConfigPopUpWindow',
  props: ['data', 'widgetForm'],
  components: { popUpWindowFieldSet },
  data() {
    return {
      resource: [],
      filterConditionDicData: [
        { label: '工号', value: 'jobNumber' },
        { label: '账号id', value: 'accountId' }
      ],
      fieldDicData: [],
      fieldAttrList: this.data.fieldAttrList || [],
      validator: {
        type: null,
        required: null,
        pattern: null,
        length: null
      }
    }
  },
  mounted() {
    this.getResource()
    // 如果所选字段有值,常饿一次
    if (this.data.resourceId) {
      this.resourceIdChange(this.data.resourceId)
    }
  },
  methods: {
    generateRule() {
      const rules = []
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]) rules.push(this.validator[key])
      })
      this.data.rules = rules
    },
    replaceFieldAttrList(data) {
      this.data.fieldAttrList = data
    },
    /** 获得配置资源 */
    getResource() {
      this.$http.post('/data-collection-resourece/table-or-view-query', { entity: {}}, {
        params: {
          pageNum: 1,
          pageSize: 999
        }
      }).then(response => {
        this.resource = response.data.records.map(item => ({ tableComment: item.tableComment, resourceId: item.id }))
      }).catch(error => this.$message.error(error.msg || error.message))
    },
    // resourceId 改变加载可选字段
    resourceIdChange(resourceId) {
      if (resourceId) {
        this.$http.get('/data-collection-resourece/field-query', {
          params: {
            resourceId
          }
        }).then(response => {
          this.fieldDicData = response.data.map(item => ({ label: item.columnComment, value: item.columnName }))
        }).catch(error => this.$message.error(error.msg || error.message))
      } else {
        this.data.fieldName = ''
        this.field = []
      }
    }
  },
  watch: {
    'data.resourceId': function(val) {
      if (val) {
        this.resourceIdChange(val)
      }
    },
    'data.required': function(val) {
      if (val) this.validator.required = { required: true, message: `${this.data.label}必须填写` }
      else this.validator.required = null
      this.generateRule()
    }
  }
}
</script>
